// Иконка FatSecret — зелёная «замочная скважина» в кольце (официальный знак).
// Один источник правды: используется во всех местах (дневник, главная, онбординг,
// настройки). Inline-SVG, цвет/размер настраиваются.

export function FatSecretIcon({ size = 16, color = '#1FA838' }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true" style={{ display: 'block' }}>
      {/* Кольцо */}
      <circle cx="24" cy="24" r="19" fill="none" stroke={color} strokeWidth="4" />
      {/* Замочная скважина: круг сверху + расширяющийся книзу стебель */}
      <circle cx="24" cy="19" r="5.4" fill={color} />
      <path d="M22 22.5 L19.3 32.5 H28.7 L26 22.5 Z" fill={color} />
    </svg>
  )
}
